import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL || "";

const legalTexts = {
  privacy: {
    title: "Informativa Privacy",
    body: [
      "Dallo Zio Roby tratta i dati inseriti in fase di registrazione per creare e gestire l'account cliente, consentire l'utilizzo dell'app, gestire ordini, wallet, punti fedeltà, comunicazioni di servizio e assistenza.",
      "I dati trattati possono includere nome, cognome, email, data di nascita, comune o zona indicata, dati tecnici di registrazione come indirizzo IP e dispositivo/browser utilizzato, storico ordini, movimenti wallet, punti fedeltà e preferenze promozionali.",
      "I dati vengono utilizzati esclusivamente per finalità legate al servizio richiesto, alla gestione del rapporto cliente, alla sicurezza dell'account, alla prevenzione di abusi e, solo in caso di consenso, per comunicazioni promozionali.",
      "Il conferimento dei dati necessari alla registrazione è obbligatorio per usare l'app. Il consenso marketing è facoltativo e può essere revocato in qualsiasi momento.",
      "I dati sono conservati per il tempo necessario alla gestione del servizio, agli obblighi fiscali, amministrativi e di tutela dei diritti del titolare. L'utente può richiedere accesso, rettifica, cancellazione, limitazione o opposizione al trattamento nei limiti previsti dalla normativa.",
      "Per richieste relative alla privacy è possibile rivolgersi al punto vendita Dallo Zio Roby o ai recapiti comunicati dal titolare del servizio."
    ]
  },
  terms: {
    title: "Termini di utilizzo dell'app",
    body: [
      "L'app Dallo Zio Roby permette al cliente di consultare prodotti, promozioni, punti fedeltà, wallet/credito app e inviare ordini collegati al punto vendita di riferimento.",
      "L'utente è responsabile della correttezza dei dati inseriti e della custodia delle proprie credenziali. In caso di uso non autorizzato dell'account, il cliente deve informare tempestivamente il punto vendita.",
      "Gli ordini effettuati tramite app sono soggetti a disponibilità reale dei prodotti, verifica del punto vendita, orari di ritiro e correttezza dei dati inseriti. Il punto vendita può contattare il cliente per chiarimenti o modifiche necessarie.",
      "Prezzi, disponibilità, promozioni e condizioni possono essere aggiornati. In caso di errore evidente, malfunzionamento tecnico o indisponibilità, il punto vendita potrà annullare o modificare l'ordine previo contatto con il cliente.",
      "Il wallet/credito app può essere utilizzato secondo le regole previste dal servizio. Eventuali bonus, promozioni o credito promozionale possono avere condizioni specifiche e non sempre generare punti fedeltà.",
      "È vietato usare l'app in modo improprio, fraudolento, offensivo o contrario alla legge. Il punto vendita può sospendere o limitare l'account in caso di abuso o uso non corretto.",
      "L'utilizzo dell'app comporta l'accettazione delle presenti condizioni e delle eventuali modifiche future comunicate o rese disponibili nell'app."
    ]
  },
  alcohol: {
    title: "Condizioni relative alla vendita di alcolici",
    body: [
      "La vendita e la somministrazione di bevande alcoliche a minori di 18 anni è vietata. Utilizzando l'app, il cliente dichiara sotto la propria responsabilità di essere maggiorenne.",
      "I prodotti alcolici possono includere, a titolo esemplificativo, vino sfuso, vino in bottiglia, prosecco, birra, amari, grappe, liquori e prodotti simili.",
      "Il punto vendita può richiedere un documento di identità valido al momento del ritiro o prima dell'abilitazione agli acquisti online di prodotti alcolici.",
      "In assenza di verifica dell'età, o in caso di dubbi sull'identità o sulla maggiore età del cliente, il punto vendita potrà rifiutare la consegna o il ritiro dei prodotti alcolici, anche se l'ordine è stato inviato tramite app.",
      "La dichiarazione falsa della maggiore età o l'utilizzo dell'account da parte di minori costituisce uso improprio del servizio e può comportare la sospensione dell'account.",
      "L'app è pensata principalmente per un utilizzo locale collegato al punto vendita e al ritiro in negozio. L'acquisto di prodotti alcolici resta soggetto alle verifiche e alla normativa italiana applicabile."
    ]
  },
  marketing: {
    title: "Consenso comunicazioni promozionali",
    body: [
      "Con il consenso marketing, il cliente autorizza Dallo Zio Roby a inviare comunicazioni relative a promozioni, offerte, iniziative fedeltà, campagne wallet, novità e comunicazioni commerciali collegate al punto vendita.",
      "Il consenso è facoltativo. Il mancato consenso non impedisce la registrazione e l'utilizzo dell'app.",
      "Il cliente può revocare il consenso in qualsiasi momento rivolgendosi al punto vendita o tramite gli strumenti che saranno resi disponibili nell'app."
    ]
  }
};

export default function AppRegisterPage() {
  const navigate = useNavigate();
  const location = useLocation();

  const requestedReturnTo = location.state?.returnTo;
  const returnTo =
    requestedReturnTo === "/app/carrello" ||
    requestedReturnTo === "/app/wallet"
      ? requestedReturnTo
      : "/app";

  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    phone: "",
    email: "",
    confirm_email: "",
    password: "",
    confirm_password: "",
    birth_date: "",
    source_area: "",
      store_id: "",
    is_adult_confirmed: false,
    privacy_accepted: false,
    terms_accepted: false,
    alcohol_policy_accepted: false,
    marketing_consent: false,
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [stores, setStores] = useState([]);
  const [err, setErr] = useState("");
  const [ok, setOk] = useState("");
  const [legalModal, setLegalModal] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/app/stores/`)
      .then((res) => res.json())
      .then((data) => {
        const list = Array.isArray(data) ? data : (data.results || []);
        setStores(list);

      })
      .catch(() => setStores([]));
  }, []);

  const openLegal = (key) => setLegalModal(legalTexts[key] || null);
  const closeLegal = () => setLegalModal(null);

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setOk("");
    setLoading(true);

    const emailClean = String(form.email || "").trim().toLowerCase();
    const confirmEmailClean = String(form.confirm_email || "").trim().toLowerCase();

    if (emailClean !== confirmEmailClean) {
      setErr("Le email non coincidono. Controlla di averle scritte correttamente.");
      setLoading(false);
      return;
    }

    if (form.password !== form.confirm_password) {
      setErr("Le password non coincidono.");
      setLoading(false);
      return;
    }

    try {
      const { confirm_password, ...registrationData } = form;
      const payload = {
        ...registrationData,
        email: emailClean,
        confirm_email: confirmEmailClean,
      };

      const res = await fetch(`${API_URL}/api/app/register/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(data?.detail || "Errore registrazione.");
      }

      setOk("Registrazione completata con successo. Ora puoi accedere.");
      setTimeout(() => navigate("/app/login", { state: { returnTo } }), 1500);
    } catch (e2) {
      setErr(e2.message || "Errore imprevisto.");
    } finally {
      setLoading(false);
    }
  };

  const LegalLink = ({ children, modalKey }) => (
    <button
      type="button"
      className="btn btn-link p-0 align-baseline"
      onClick={() => openLegal(modalKey)}
    >
      {children}
    </button>
  );

  return (
    <div className="container py-4" style={{ maxWidth: 650 }}>
      <div className="card shadow border-0 rounded-4">
        <div className="card-body p-4">
          <h2 className="mb-1 text-center">🍷 Registrazione App</h2>
          <p className="text-muted text-center mb-4">
            Registrati per ordinare vino sfuso, ricaricare il wallet e usare i vantaggi fedeltà.
          </p>

          {err && <div className="alert alert-danger">{err}</div>}
          {ok && <div className="alert alert-success">{ok}</div>}

          <form onSubmit={submit}>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label">Nome</label>
                <input className="form-control" name="first_name" value={form.first_name} onChange={onChange} required />
              </div>

              <div className="col-md-6">
                <label className="form-label">Cognome</label>
                <input className="form-control" name="last_name" value={form.last_name} onChange={onChange} required />
              </div>

              <div className="col-12">
                <label className="form-label">
                  Cellulare <span className="text-danger">*</span>
                </label>
                <input
                  type="tel"
                  className="form-control"
                  name="phone"
                  value={form.phone}
                  onChange={onChange}
                  autoComplete="tel"
                  inputMode="tel"
                  placeholder="Es. 3331234567"
                  required
                />
                <div className="form-text">
                  Il numero è necessario per comunicazioni relative al servizio e all'account.
                </div>
              </div>

              <div className="col-12">
                <label className="form-label">Email</label>
                <input type="email" className="form-control" name="email" value={form.email} onChange={onChange} required />
              </div>

              <div className="col-12">
                <label className="form-label">Conferma email</label>
                <input
                  type="email"
                  className={`form-control ${form.confirm_email && String(form.email).trim().toLowerCase() !== String(form.confirm_email).trim().toLowerCase() ? "is-invalid" : ""}`}
                  name="confirm_email"
                  value={form.confirm_email}
                  onChange={onChange}
                  required
                />
                {form.confirm_email && String(form.email).trim().toLowerCase() !== String(form.confirm_email).trim().toLowerCase() && (
                  <div className="invalid-feedback">
                    Le email non coincidono.
                  </div>
                )}
              </div>

              <div className="col-12">
                <label className="form-label">Password</label>
                <div className="input-group"><input type={showPassword ? "text" : "password"} className="form-control" name="password" value={form.password} onChange={onChange} minLength={8} required /><button type="button" className="btn btn-outline-secondary" onClick={() => setShowPassword(!showPassword)} aria-label={showPassword ? "Nascondi password" : "Mostra password"} aria-pressed={showPassword}>{showPassword ? "🙈" : "👁"}</button></div>
              </div>

              <div className="col-12">
                <label className="form-label">Conferma password</label>
                <div className="input-group">
                  <input type={showConfirmPassword ? "text" : "password"} className="form-control" name="confirm_password" value={form.confirm_password} onChange={onChange} autoComplete="new-password" minLength={8} required />
                  <button type="button" className="btn btn-outline-secondary" onClick={() => setShowConfirmPassword(!showConfirmPassword)} aria-label={showConfirmPassword ? "Nascondi conferma password" : "Mostra conferma password"}>{showConfirmPassword ? "🙈" : "👁"}</button>
                </div>
                {form.confirm_password && form.password !== form.confirm_password && <div className="text-danger small mt-1">Le password non coincidono.</div>}
              </div>

              <div className="col-md-6">
                <label className="form-label">Data di nascita</label>
                <input type="date" className="form-control" name="birth_date" value={form.birth_date} onChange={onChange} required />
              </div>

              <div className="col-md-6">
                <label className="form-label">Comune / Zona</label>
                <input className="form-control" name="source_area" value={form.source_area} onChange={onChange} placeholder="es. Busto Arsizio" />
              </div>

                <div className="col-12">
                  <label className="form-label">Punto vendita di riferimento</label>
                  <select
                    className="form-select"
                    name="store_id"
                    value={form.store_id}
                    onChange={onChange}
                    required
                  >
                    <option value="">Seleziona punto vendita</option>
                    {stores.map((s) => (
                      <option key={s.id} value={s.id}>
                        {s.display_name || s.name || s.code}
                      </option>
                    ))}
                  </select>
                  <div className="small text-muted mt-1">
                    Scegli lo store a cui vuoi collegare il tuo account app.
                  </div>
                </div>
            </div>

            <hr className="my-4" />

            <div className="alert alert-warning small">
              Per utilizzare l'app e ordinare prodotti alcolici devi essere maggiorenne.
              La verifica finale potrà essere richiesta al momento del ritiro in negozio.
            </div>

            <div className="form-check mb-3">
              <input id="adult" className="form-check-input" type="checkbox" name="is_adult_confirmed" checked={form.is_adult_confirmed} onChange={onChange} required />
              <label htmlFor="adult" className="form-check-label">Confermo di essere maggiorenne.</label>
            </div>

            <div className="form-check mb-3">
              <input id="privacy" className="form-check-input" type="checkbox" name="privacy_accepted" checked={form.privacy_accepted} onChange={onChange} required />
              <label htmlFor="privacy" className="form-check-label">
                Accetto l' <a
                    href="https://gestionale.dallozioroby.it/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Informativa Privacy
                  </a>.
              </label>
            </div>

            <div className="form-check mb-3">
              <input id="terms" className="form-check-input" type="checkbox" name="terms_accepted" checked={form.terms_accepted} onChange={onChange} required />
              <label htmlFor="terms" className="form-check-label">
                Accetto i <a
                    href="https://gestionale.dallozioroby.it/termini"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Termini di utilizzo dell'app
                  </a>.
              </label>
            </div>

            <div className="form-check mb-3">
              <input id="alcohol" className="form-check-input" type="checkbox" name="alcohol_policy_accepted" checked={form.alcohol_policy_accepted} onChange={onChange} required />
              <label htmlFor="alcohol" className="form-check-label">
                Accetto le <LegalLink modalKey="alcohol">condizioni relative alla vendita di alcolici</LegalLink>.
              </label>
            </div>

            <div className="form-check mb-4">
              <input id="marketing" className="form-check-input" type="checkbox" name="marketing_consent" checked={form.marketing_consent} onChange={onChange} />
              <label htmlFor="marketing" className="form-check-label">
                Acconsento a ricevere <LegalLink modalKey="marketing">promozioni e offerte</LegalLink>.
              </label>
            </div>

            <button className="btn btn-success w-100 btn-lg" disabled={loading}>
              {loading ? "Registrazione..." : "Crea account"}
            </button>

            <button type="button" className="btn btn-outline-secondary w-100 mt-3" onClick={() => navigate("/app/login", { state: { returnTo } })}>
              Hai già un account? Accedi
            </button>
          </form>
        </div>
      </div>

      {legalModal && (
        <div
          className="modal d-block"
          tabIndex="-1"
          role="dialog"
          style={{ background: "rgba(0,0,0,0.45)" }}
        >
          <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
            <div className="modal-content rounded-4">
              <div className="modal-header">
                <h5 className="modal-title">{legalModal.title}</h5>
                <button type="button" className="btn-close" onClick={closeLegal} aria-label="Chiudi"></button>
              </div>

              <div className="modal-body">
                {legalModal.body.map((paragraph, idx) => (
                  <p key={idx} className="mb-3">
                    {paragraph}
                  </p>
                ))}
              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={closeLegal}>
                  Chiudi
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
